class BundleBox {
  constructor(apiUrl, productPlatformId) {
    this._apiUrl = apiUrl;
    this._productPlatformId = productPlatformId;

    this._elements = {
      container: document.querySelector('.skio-bundle-builder__container'),
      boxContainer: document.querySelector('.skio-bundle-builder__products'),
      remainQuantityBlock: document.querySelector('[data-remain-quantity]'),
      subtotalSumBlock: document.querySelector('[data-subtotal-sum]'),
      saveBlock: document.querySelector('[data-discount-sum]'),
      checkoutBlock: document.querySelector('.skio-bundle-builder__checkout-block'),
      checkoutButton: document.querySelector('.skio-bundle-builder__checkout'),
      remainQuantityContainer: document.querySelector('.skio-bundle-builder__note'),
      alertContainer: document.querySelector('.skio-bundle-builder__alert'),
      bundleCart: document.querySelector('[data-cart-items]'),
      closeButton: document.querySelector('.skio-bundle-builder__cart-close'),
      deliveryBlock: document.querySelector('.skio-bundle-builder__delivery-days'),
    };

    this._bundleItems = [];
    this._sellingPlanId = null;
    this._selectableProductVariants = [];
    this._sellingPlanGroup = null;
    this._percentDiscountTier = null;
    this._totalQuantity = 0;
    this._totalSum = 0;
    this._removeAlert = null;
    this._boxId = null;
    this._listeners = [];
    this._preselectedSellingPlanFrequency = 2;
    this._recommendedSellingPlanFrequency = 2;
    if (this._elements.deliveryBlock) {
      this._deliveryDays = parseInt(this._elements.deliveryBlock.dataset.deliveryDays, 10);
    } else {
      this._deliveryDays = 0;
    }
    
    this._init();
  }

  async _init() {
    const data = await this._fetchData();

    this._addToCartText = this._elements.container?.dataset.addToCartText || 'Add to Basket';

    this._svgDelete = `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.5 3.5L4.125 13.4999C4.15469 14.0778 4.575 14.5001 5.125 14.5001H10.875C11.4272 14.5001 11.8397 14.0778 11.875 13.4999L12.5001 3.5" stroke="black" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M2.5 3.5H13.4999" stroke="black" stroke-width="0.9375" stroke-miterlimit="10" stroke-linecap="round"/>
      <path d="M10.25 5.5L10 12.5001M8 5.5V12.5001M5.75 5.5L6.00001 12.5001M6.00001 3.5V2.25001C5.99972 2.15144 6.01892 2.05377 6.05651 1.96265C6.0941 1.87152 6.14933 1.78873 6.21903 1.71903C6.28873 1.64933 6.37153 1.59409 6.46265 1.5565C6.55378 1.51892 6.65143 1.49972 6.75 1.5H9.25001C9.34858 1.49972 9.44623 1.51892 9.53736 1.5565C9.62848 1.59409 9.71128 1.64933 9.78098 1.71903C9.85068 1.78873 9.90591 1.87152 9.9435 1.96265C9.98109 2.05377 10.0003 2.15144 10 2.25001V3.5H6.00001Z" stroke="black" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    `;

    this._svgTick = `
      <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 6.5C12 8.0913 11.3679 9.61742 10.2426 10.7426C9.11742 11.8679 7.5913 12.5 6 12.5C4.4087 12.5 2.88258 11.8679 1.75736 10.7426C0.632141 9.61742 0 8.0913 0 6.5C0 4.9087 0.632141 3.38258 1.75736 2.25736C2.88258 1.13214 4.4087 0.5 6 0.5C7.5913 0.5 9.11742 1.13214 10.2426 2.25736C11.3679 3.38258 12 4.9087 12 6.5ZM9.0225 4.2275C8.96893 4.17411 8.90514 4.13208 8.83495 4.10391C8.76476 4.07574 8.68961 4.06202 8.61399 4.06356C8.53838 4.0651 8.46385 4.08187 8.39486 4.11288C8.32588 4.14388 8.26385 4.18848 8.2125 4.244L5.60775 7.56275L4.038 5.99225C3.93137 5.89289 3.79033 5.8388 3.64461 5.84137C3.49888 5.84394 3.35984 5.90297 3.25678 6.00603C3.15372 6.10909 3.09469 6.24813 3.09212 6.39386C3.08955 6.53958 3.14364 6.68062 3.243 6.78725L5.2275 8.7725C5.28096 8.82586 5.34462 8.86791 5.41469 8.89614C5.48475 8.92437 5.55979 8.93819 5.63531 8.93679C5.71083 8.93539 5.7853 8.9188 5.85427 8.88799C5.92324 8.85719 5.9853 8.81281 6.03675 8.7575L9.03075 5.015C9.13282 4.90887 9.18921 4.76696 9.18781 4.61972C9.1864 4.47248 9.12732 4.33166 9.02325 4.2275H9.0225Z" fill="#282828"/>
      </svg>
    `;

    this._svgDropdown = `
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 13.3333L15.5556 7.7777" stroke="#121212" stroke-linecap="round"/>
        <path d="M10 13.3333L4.44444 7.7777" stroke="#121212" stroke-linecap="round"/>
      </svg>
    `;

    this._svgMinus = `
      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.5 10.3335H17.5" stroke="#282828" stroke-linecap="round"/>
      </svg>
    `;

    this._svgPlus =`
      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.5 10.3336H17.5M10 2.8335L10 17.8335" stroke="#282828" stroke-linecap="round"/>
      </svg>
    `;

    if (data && data.DynamicBox) {
      const dynamicBox = data.DynamicBox;
      this._sizeInterval = dynamicBox.sizeInterval;
      this._preselectedSize = dynamicBox.sizeInterval[0];
      this._selectableProductVariants = dynamicBox.selectableProductVariants || [];
      this._sellingPlanGroup = dynamicBox.sellingPlanGroup;
      this._percentDiscountTier = dynamicBox.percentDiscountTier;
      this._dafaultOneTime = dynamicBox.settings.defaultOneTime;
      this._productGroupingOrder = dynamicBox.settings.productGroupingOrder;
      this._productGrouping = dynamicBox.settings.productGrouping;
      this._boxId = dynamicBox.boxId;

      this._groupedProducts = {};

      this._selectableProductVariants.forEach(variant => {
        const productId = variant.productPlatformId?.match(/\d+$/)?.[0];

        const categories = Object.keys(this._productGrouping).filter(cat =>
          this._productGrouping[cat].includes(productId)
        );

        if (categories.length === 0) categories.push('Other');

        categories.forEach(category => {
          if (!this._groupedProducts[category]) {
            this._groupedProducts[category] = [];
          }

          const variantCopy = { ...variant };
          this._groupedProducts[category].push(variantCopy);
        });
      });

      this._renderIntervalBlocks();
      this._renderSellingPlans(this._sellingPlanGroup);
      this._addSellingPlanPercent();
      this._setupPurchaseOptionListener();
      this._setupIntervalOptionListener();
      const intervalBlock = document.querySelector('[data-box-interval]');
      this._updateIntervalPriceBlock(intervalBlock);
      const size = this._getCheckedRadioValue('bundle-size');
      this._enableFreeGifts(size);
      this._renderProductCards();
      this._isGiftSelected();
      this._setupCheckoutButtonListener();
      this._updateRemainingQuantityBlock();
      this._setupCartCloseHandler();
      this._updateCloseButtonState();
      this._setupGiftOptionListener();
      this._showTotalsOnScroll();
      this._setDeliveryDate();
    }
  }

  async _fetchData() {
    try {
      const res = await fetch(this._apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': '*/*'
        },
        body: JSON.stringify({
          productPlatformId: this._productPlatformId, 
        }),
      });

      if (!res.ok) {
        return null;
      }

      return await res.json();
    } catch (error) {
      console.error('Error:', error);
      return null;
    }
  }

  _formatMoney(amount) {
    const currency = Shopify?.currency?.active || 'GBP';
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: currency
    }).format(Number(amount));
  }

  _getCheapestSelectableVariant() {
    const allVariants = this._getAllVariants(this._selectableProductVariants);
    const cheapestVariant = this._getCheapestVariant(allVariants);
    return cheapestVariant;
  }

  _renderIntervalBlocks() {
    this._scaleElements = [];
    const container = document.querySelector('[data-box-interval]');
    container.innerHTML = '';

    const intervals = JSON.parse(container.dataset.intervals);

    this._sizeInterval.forEach((size) => {
      const intervalOpt = intervals.find(opt => opt.size == size);
      if (!intervalOpt) return; 

      const label = document.createElement('label');

      const input = document.createElement('input');
      input.type = 'radio';
      input.name = 'bundle-size';
      input.value = size;
      input.classList.add('visually-hidden');
      if (input.value == this._preselectedSize) input.checked = true;

      label.appendChild(input);

      const sizeText = document.createElement('span'); 
      sizeText.classList.add('interval-title');
      sizeText.textContent = `${size} boxes`;

      const img = document.createElement('img');
      img.src = intervalOpt.image;
      img.alt = `${size} boxes`;

      const intervalPriceBlock = document.createElement('span');
      intervalPriceBlock.classList.add('skio-bundle-builder__price-block');

      const cheapestVariant = this._getCheapestSelectableVariant(size);
      this._renderPriceContainer(cheapestVariant, size, intervalPriceBlock);

      const badgeText = container.getAttribute('data-badge-text');
      const intervalPriceBadge = document.createElement('span');
      intervalPriceBadge.classList.add('skio-bundle-builder__interval-badge', 'box-badge', 'box-badge--dark');
      intervalPriceBadge.textContent = `${this._formatMoney(cheapestVariant.price)} ${badgeText}`;

      if (this._percentDiscountTier && this._percentDiscountTier[size] !== undefined) {
        const discountContainer = document.createElement('div');
        discountContainer.classList.add('discount-container');

        const discountBlock = document.createElement('div');
        discountBlock.classList.add('discount-block', 'box-badge');
        discountBlock.textContent = (this._percentDiscountTier[size] > 0) 
          ? `${this._percentDiscountTier[size]}% off` 
          : '';

        discountContainer.appendChild(discountBlock);
        label.appendChild(discountContainer);
      }

      label.appendChild(sizeText);
      label.appendChild(img);
      label.appendChild(intervalPriceBlock);
      label.appendChild(intervalPriceBadge);

      container.appendChild(label);
      this._scaleElements.push(input);
    });
  }

  _getCheapestVariant(allVariants) {
    if (!allVariants || allVariants.length === 0) return null;

    const cheapest = allVariants.reduce((cheapest, variant) => {
      return variant.price < cheapest.price ? variant : cheapest;
    }, allVariants[0]);

    return {
      price: cheapest.price,
      compareAtPrice: cheapest.compareAtPrice
    };
  }

  _getAllVariants(products) {
    return products.flatMap(product => product.productVariants);
  }

  _getCheapestAdjustedVariant(sellingPlans) {
    let cheapestVariant = null;

    for (const planId in sellingPlans) {
      const variantMapping = sellingPlans[planId].variantMapping;

      for (const variantId in variantMapping) {
        const variant = variantMapping[variantId];

        if (!cheapestVariant || variant.adjustedPrice < cheapestVariant.adjustedPrice) {
          cheapestVariant = {
            variantId,
            planId: variant.planId,
            adjustedPrice: this._roundedNumber(variant.adjustedPrice)
          };
        }
      }
    }
    return cheapestVariant;
  }

  _roundedNumber(value) {
   return Math.round(value * 100) / 100;
  }

  _getMaxPriceAdjustmentAmount(sellingPlans) {
    let maxAdjustment = 0;

    const plansArray = Object.values(sellingPlans);

    for (const plan of plansArray) {
      if (plan.priceAdjustmentAmount > maxAdjustment) {
        maxAdjustment = plan.priceAdjustmentAmount;
      }
    }

    return maxAdjustment;
  }

  _getCheapestSubscriptionPrice() {
    const cheapestSubscription = this._getCheapestAdjustedVariant(this._sellingPlanGroup);
    return cheapestSubscription ? cheapestSubscription.adjustedPrice : 0;
  }

  _renderSellingPlans(sellingPlanGroup) {
    const container = document.querySelector('[data-selling-plans]');
    container.innerHTML = '';

    const cheapestVariant = this._getCheapestSelectableVariant();
    const cheapestAdjustedVariant = this._getCheapestAdjustedVariant(sellingPlanGroup);
    const size = this._getSelectedBundleTotalSize();

    const { sortedPlans, planIds } = this._getSortedPlans(sellingPlanGroup);

    const sellingPlansContainer = this._createSellingPlansSection(
      sortedPlans,
      planIds,
      cheapestVariant,
      cheapestAdjustedVariant,
      size,
      container
    );
    container.appendChild(sellingPlansContainer);

    const oneTimeContainer = this._createOneTimeSection(cheapestVariant, size);
    container.appendChild(oneTimeContainer);

    this._attachPurchaseOptionHandlers();
  }

  _getSortedPlans(sellingPlanGroup) {
    const sortedPlans = Object.values(sellingPlanGroup).sort(
      (a, b) => a.position - b.position
    );

    const planIdsOrdered = Object.keys(sellingPlanGroup).sort(
      (a, b) => sellingPlanGroup[a].position - sellingPlanGroup[b].position
    );

    const planIds = planIdsOrdered.map(id => id.split('/').pop());

    return { sortedPlans, planIds };
  }

  _createSellingPlansSection(plans, planIds, cheapestVariant, cheapestAdjustedVariant, size, dataContainer) {
    const container = document.createElement('div');
    container.classList.add(
      'skio-bundle-builder__purchase-option',
      'skio-bundle-builder__purchase-option--selling-plans'
    );

    const hasPlans = plans && plans.length > 0;
    if (!hasPlans) {
      container.classList.add('disabled');
      container.style.pointerEvents = 'none'; 
      container.style.opacity = '0.5';
    }

    const title = this._createSellingPlansTitle();
    container.appendChild(title);

    const subtitleContainer = this._createSellingPlansSubtitle(
      cheapestVariant,
      cheapestAdjustedVariant,
      size,
      dataContainer
    );
    container.appendChild(subtitleContainer);

    const dropdown = this._createPlansDropdown(plans, planIds, size);
    container.appendChild(dropdown);

    if (window.listItems && Array.isArray(window.listItems)) {
      const list = this._createBenefitsList();
      container.appendChild(list);
    }

    return container;
  }

  _createSellingPlansTitle() {
    const title = document.createElement('div');
    title.classList.add('skio-bundle-builder__selling-plans-title');

    const content = document.createElement('div');
    content.classList.add('skio-bundle-builder__selling-plans-content');
    content.innerHTML = 'Subscribe & save <span data-total-percent></span> on every order';

    title.appendChild(content);
    return title;
  }

  _createSellingPlansSubtitle(cheapestVariant, cheapestAdjustedVariant, size, dataContainer) {
    const container = document.createElement('div');
    container.classList.add('skio-bundle-builder__purchase-subtitle-container');

    const subtitle = document.createElement('div');
    subtitle.classList.add('skio-bundle-builder__purchase-subtitle');
    subtitle.textContent = 'Subscribe & save';
    container.appendChild(subtitle);

    const saveBadge = this._createSaveBadge(
      cheapestVariant,
      cheapestAdjustedVariant,
      size,
      dataContainer
    );
    container.appendChild(saveBadge);

    const priceBlock = document.createElement('span');
    priceBlock.classList.add('skio-bundle-builder__price-block', 'subscription-price');
    this._renderPriceContainer(cheapestVariant, size, priceBlock, false, true);
    container.appendChild(priceBlock);

    return container;
  }

  _createSaveBadge(cheapestVariant, cheapestAdjustedVariant, size, dataContainer) {
    const badge = document.createElement('div');
    badge.classList.add('skio-bundle-builder__selling-plans-save', 'box-badge');

    const { difference } = this._calculateSubscriptionDiscountSum(
      cheapestVariant,
      cheapestAdjustedVariant,
      size
    );

    const discountText = dataContainer.getAttribute('data-badge-discount-text') ?? '';
    badge.textContent = `${discountText} ${this._formatMoney(difference)}`;

    return badge;
  }

  _createPlansDropdown(plans, planIds, size) {
    const dropdown = document.createElement('div');
    dropdown.classList.add('custom-dropdown');

    const bundleDiscount = +this._percentDiscountTier[size];

    const icon = document.createElement('div');
    icon.classList.add('dropdown-icon');
    icon.innerHTML = this._svgDropdown;
    dropdown.appendChild(icon);

    const selected = document.createElement('div');
    selected.classList.add('selected');
    selected.textContent = 'Select a plan';
    dropdown.appendChild(selected);

    const optionsContainer = document.createElement('div');
    optionsContainer.classList.add('options');
    const optionsList = document.createElement('div');
    optionsList.classList.add('options__list');
    optionsContainer.appendChild(optionsList);
    dropdown.appendChild(optionsContainer);

    this._populatePlansOptions(
      optionsList,
      plans,
      planIds,
      bundleDiscount,
      selected
    );

    this._attachDropdownHandlers(selected, optionsContainer);

    return dropdown;
  }

  _findSellingPlanIndexByInterval(intervalCount) {
    const sellingPlansData = this._sellingPlanGroup;
    
    if (!sellingPlansData) return -1;
    
    const plan = Object.values(sellingPlansData).find(
      plan => plan.intervalCount == intervalCount
    );
    
    return plan ? plan.position : -1;
  }

  _populatePlansOptions(container, plans, planIds, bundleDiscount, selectedElement) {
    const preselectedIndex = this._findSellingPlanIndexByInterval(this._preselectedSellingPlanFrequency);
    const recommendedIndex = this._findSellingPlanIndexByInterval(this._recommendedSellingPlanFrequency);

    plans.forEach((plan, idx) => {
      const label = document.createElement('label');
      const input = this._createPlanInput(plan, planIds[idx]);

      label.appendChild(input);

      const totalDiscount = plan.priceAdjustmentAmount + bundleDiscount;

      label.insertAdjacentHTML(
        'beforeend',
        `Delivery ${plan.title.toLowerCase()}, - <span><span data-total-discount>${totalDiscount}</span>% OFF</span>`
      );

      if (!this._dafaultOneTime && idx === preselectedIndex) {      
        input.checked = true;
        this._updateSelectedText(label, selectedElement);
      }

      if (idx === recommendedIndex) {
        label.classList.add('order-first');
        const labelBadge = document.createElement('span');
        labelBadge.classList.add('box-badge');
        labelBadge.textContent = 'Recommended';
        label.appendChild(labelBadge);

        if (selectedElement) {
          const selectedBadge = document.createElement('span');
          const labelBadge = document.createElement('span');
          labelBadge.classList.add('box-badge');
          labelBadge.textContent = 'Recommended';
          selectedElement.appendChild(labelBadge);
          selectedElement.appendChild(selectedBadge);
        }
      }

      container.appendChild(label);
    });
  }

  _createPlanInput(plan, planId) {
    const input = document.createElement('input');
    input.classList.add('visually-hidden');
    input.type = 'radio';
    input.name = 'purchase-option';
    input.value = planId;
    input.dataset.radioType = 'selling_plan';
    input.dataset.priceAdjustmentAmount = plan.priceAdjustmentAmount;

    return input;
  }

  _updateSelectedText(label, selectedElement) {
    const clone = label.cloneNode(true);
    const inputInClone = clone.querySelector('input');
    if (inputInClone) inputInClone.remove();
    selectedElement.innerHTML = clone.innerHTML.trim();
  }

  _attachDropdownHandlers(selected, optionsContainer) {
    const toggleOptions = () => {
      const isVisible = optionsContainer.style.display === 'block';
      optionsContainer.style.display = isVisible ? 'none' : 'block';
    };

    selected.addEventListener('click', toggleOptions);
    this._listeners.push({ el: selected, type: 'click', fn: toggleOptions });

    optionsContainer.querySelectorAll('input[type="radio"]').forEach(input => {
      const onPlanSelect = () => {
        input.checked = true;
        const label = input.closest('label');
        if (!label) return;

        this._updateSelectedText(label, selected);
        optionsContainer.style.display = 'none';
      };

      input.addEventListener('change', onPlanSelect);
      this._listeners.push({ el: input, type: 'change', fn: onPlanSelect });
    });
  }

  _createBenefitsList() {
    const ul = document.createElement('ul');
    ul.classList.add('skio-bundle-builder__subscription-list');

    window.listItems.forEach(item => {
      const li = document.createElement('li');
      li.innerHTML = `${this._svgTick}<span>${item.trim()}</span>`;
      ul.appendChild(li);
    });

    return ul;
  }

  _createOneTimeSection(cheapestVariant, size) {
    const container = document.createElement('div');
    container.classList.add(
      'skio-bundle-builder__purchase-option',
      'skio-bundle-builder__purchase-option--one-time'
    );

    const label = document.createElement('label');

    const input = this._createOneTimeInput();

    const hasSellingPlans = this._sellingPlanGroup && Object.keys(this._sellingPlanGroup).length > 0;
    if (!hasSellingPlans) {
      input.checked = true;
    }

    label.appendChild(input);

    const subtitleContainer = this._createOneTimeSubtitle(cheapestVariant, size);
    label.appendChild(subtitleContainer);

    if (window.oneTimePurchaseItem) {
      const text = document.createElement('div');
      text.classList.add('skio-bundle-builder__one-time-text');
      text.textContent = window.oneTimePurchaseItem;
      label.appendChild(text);
    }

    container.appendChild(label);
    return container;
  }

  _createOneTimeInput() {
    const input = document.createElement('input');
    input.classList.add('visually-hidden');
    input.type = 'radio';
    input.name = 'purchase-option';
    input.value = 'one-time';
    input.dataset.radioType = 'one_time_purchase';

    if (this._dafaultOneTime) {
      input.checked = true;
    }

    return input;
  }

  _createOneTimeSubtitle(cheapestVariant, size) {
    const container = document.createElement('div');
    container.classList.add('skio-bundle-builder__purchase-subtitle-container');

    const subtitle = document.createElement('div');
    subtitle.classList.add('skio-bundle-builder__purchase-subtitle');
    subtitle.textContent = 'One time purchase';
    container.appendChild(subtitle);

    const priceBlock = document.createElement('span');
    priceBlock.classList.add('skio-bundle-builder__price-block', 'one-time-price');
    this._renderPriceContainer(cheapestVariant, size, priceBlock, false, false, true);
    container.appendChild(priceBlock);

    return container;
  }

  _attachPurchaseOptionHandlers() {
    const sellingPlansBlock = document.querySelector('.skio-bundle-builder__purchase-option--selling-plans');
    const oneTimeBlock = document.querySelector('.skio-bundle-builder__purchase-option--one-time');
    const intervalBlock = document.querySelector('[data-box-interval]');

    if (!sellingPlansBlock || !oneTimeBlock) return;

    const onSellingPlansClick = (e) => {
      if (e.target.closest('.custom-dropdown')) return;
      this._handleSellingPlansSelection(sellingPlansBlock, oneTimeBlock, intervalBlock);
    };

    const onOneTimeClick = () => {
      this._handleOneTimeSelection(sellingPlansBlock, oneTimeBlock, intervalBlock);
    };

    this._addListener(sellingPlansBlock, 'click', onSellingPlansClick);
    this._addListener(oneTimeBlock, 'click', onOneTimeClick);
  }

  _handleSellingPlansSelection(sellingPlansBlock, oneTimeBlock, intervalBlock) {
    const isAlreadySelected = sellingPlansBlock.classList.contains('active') ||
      [...sellingPlansBlock.querySelectorAll(
        'input[type="radio"][data-radio-type="selling_plan"]'
      )].some(r => r.checked);

    if (isAlreadySelected) return; 

    const sellingPlanRadios = sellingPlansBlock.querySelectorAll(
      'input[type="radio"][data-radio-type="selling_plan"]'
    );

    const defaultPosition = this._findSellingPlanIndexByInterval(this._preselectedSellingPlanFrequency);
    const defaultRadio = sellingPlanRadios[defaultPosition] || sellingPlanRadios[0];

    if (defaultRadio) {
      defaultRadio.checked = true;

      const selected = sellingPlansBlock.querySelector('.selected');
      this._updateSelectedLabel(defaultRadio, selected);
      this._updateIntervalPriceBlock(intervalBlock);
    }

    this._setRadioChecked(oneTimeBlock, false);
    this._updateAllCardPrices();
    this._updatePurchaseOption();
  }

  _handleOneTimeSelection(sellingPlansBlock, oneTimeBlock, intervalBlock) {
    this._setRadioChecked(oneTimeBlock, true);
    
    sellingPlansBlock
      .querySelectorAll('input[type="radio"][data-radio-type="selling_plan"]')
      .forEach(radio => radio.checked = false);

    const selected = sellingPlansBlock.querySelector('.selected');
    if (selected) selected.textContent = 'Select a plan';

    this._updateIntervalPriceBlock(intervalBlock);
    this._updateAllCardPrices();
    this._updatePurchaseOption();
  }

  _updateAllCardPrices() {
    setTimeout(() => {
      document.querySelectorAll('.product-card').forEach(card => {
        this._updateCardPrice(card);
      });
    }, 50);
  }

  _updatePurchaseOption() {
    this._updateBundleItemsForPurchaseOption();
    this._renderGiftItemsIfEligible();
  }

  _setRadioChecked(element, checked) {
    const radio = element?.querySelector('input[type="radio"]');
    if (radio) radio.checked = checked;
  }

  _updateSelectedLabel(firstRadio, selectedElement) {
    if (!firstRadio || !selectedElement) return;

    const label = firstRadio.closest('label');
    if (!label) return;

    const clone = label.cloneNode(true);
    clone.querySelector('input')?.remove();
    selectedElement.innerHTML = clone.innerHTML.trim();
  }

  _addListener(element, type, handler) {
    element.addEventListener(type, handler);
    this._listeners.push({ el: element, type, fn: handler });
  }

  _getSelectedBundleTotalSize() {
    const selectedInput = document.querySelector('input[name="bundle-size"]:checked');
    if (!selectedInput) return 0;

    const selectedValue = selectedInput.value;
    return selectedValue || 0;
  }

  _addSellingPlanPercent() {
    const maxSellingPlanDiscount = +this._getMaxPriceAdjustmentAmount(this._sellingPlanGroup);

    const bundleTotalSize = this._getSelectedBundleTotalSize();
    const bundlePercent = +this._percentDiscountTier[bundleTotalSize];
    const totalPercent = maxSellingPlanDiscount + bundlePercent;

    const sellingPlanPercentContainer = document.querySelector('[data-total-percent]');
    sellingPlanPercentContainer.textContent = `${totalPercent}%`;
  }

  _renderPriceContainer(cheapestVariant, size, priceBlock, showFrom = true, isSubscription = false, isOneTime = false) {
    const cheapesAdjustedtVariant = this._getCheapestAdjustedVariant(this._sellingPlanGroup);
    priceBlock.innerHTML = '';

    if (isSubscription) {
      priceBlock.setAttribute('data-subscription-price', '');
    }

    const percent = parseFloat(this._percentDiscountTier[size]) || 0;
    const discountMultiplier = (100 - percent) / 100;

    const comparePrice = document.createElement('span');
    comparePrice.classList.add('price-compare');

    let comparePriceValue = '';
    if (cheapestVariant.compareAtPrice > 0) {
      comparePriceValue =
        (cheapestVariant.compareAtPrice > cheapestVariant.price)
          ? cheapestVariant.compareAtPrice * size
          : cheapestVariant.price * size;
    } else {
      comparePriceValue = cheapestVariant.price * size;
    }

    if (isOneTime) {
      comparePrice.textContent = `${this._formatMoney(comparePriceValue)}`;
    } else {
      comparePrice.textContent = comparePriceValue ? `${this._formatMoney(comparePriceValue)}` : '';
    }

    const price = document.createElement('span');
    price.classList.add('price-default');

    let basePrice;

    if (isSubscription) {
      const adjustedPrice = (cheapesAdjustedtVariant && cheapesAdjustedtVariant.adjustedPrice > 0)
        ? cheapesAdjustedtVariant.adjustedPrice
        : cheapestVariant.price;
      basePrice = adjustedPrice * size * discountMultiplier;
    } else if (isOneTime) {
      basePrice = cheapestVariant.price * size * discountMultiplier;
    } else {
      basePrice = cheapestVariant.price * size;
    }

    if (comparePriceValue <= basePrice) {
      comparePrice.textContent = '';
    }

    price.textContent = `${showFrom ? 'From ' : ''}${this._formatMoney(basePrice)}`;

    priceBlock.appendChild(comparePrice);
    priceBlock.appendChild(price);
  }

  _isSellingPlanSelected() {
    const selectedPlan = document.querySelector('input[data-radio-type="selling_plan"]:checked');
    return !!selectedPlan;
  }

  _updateIntervalPriceBlock(block) {
    const subscriptionInput = this._isSellingPlanSelected();
    const bundleInputs = block.querySelectorAll('input[name="bundle-size"]');
    
    const allVariants = this._getAllVariants(this._selectableProductVariants);
    const cheapestVariant = this._getCheapestVariant(allVariants);
    const cheapesAdjustedtVariant = this._getCheapestAdjustedVariant(this._sellingPlanGroup);

    if (!cheapestVariant) return;

    bundleInputs.forEach((input) => {
      const intervalBadge = input.closest('label')?.querySelector('.skio-bundle-builder__interval-badge');
      const intervalDiscountBlock = input.closest('label')?.querySelector('.discount-block');
      const size = parseFloat(input.value);
      const priceDefault = input.closest('label')?.querySelector('.price-default');
      const priceCompare = input.closest('label')?.querySelector('.price-compare');

      const percent = parseFloat(this._percentDiscountTier[size]) || 0;
      const discountMultiplier = (100 - percent) / 100;
      const cheapestSum = cheapestVariant.price * size;

      if (priceCompare) {
        priceCompare.textContent = `${this._formatMoney(cheapestSum)}`;
      }

      const basePrice = subscriptionInput
        ? cheapesAdjustedtVariant.adjustedPrice * size
        : cheapestVariant.price * size;

      const discountedPrice = basePrice * discountMultiplier;

       if (priceDefault) {
        priceDefault.textContent = `From ${this._formatMoney(discountedPrice.toFixed(2))}`;
      }

      if (cheapestSum <= discountedPrice) {
        priceCompare.textContent = '';
      }

      if (intervalBadge) {
        const intervalBase = subscriptionInput
          ? cheapesAdjustedtVariant.adjustedPrice
          : cheapestVariant.price;

        const intervalDiscounted = intervalBase * discountMultiplier; 
        const badgeText = input.closest('[data-box-interval]').getAttribute('data-badge-text');

        intervalBadge.textContent = `${this._formatMoney(intervalDiscounted)} ${badgeText}`;
      }

      if (intervalDiscountBlock) {
        const maxSellingPlanDiscount = +this._getMaxPriceAdjustmentAmount(this._sellingPlanGroup);
        const boxDiscountValue = this._percentDiscountTier[size] > 0 ? +this._percentDiscountTier[size] : '';
        const totalDiscountValue = subscriptionInput ? maxSellingPlanDiscount + boxDiscountValue : boxDiscountValue;

        intervalDiscountBlock.textContent = subscriptionInput ? `${totalDiscountValue}% off` : this._percentDiscountTier[size] > 0 ? `${totalDiscountValue}% off` : '';
      }
    });
  }

  _getVariantPriceById(variantId) {
    const allVariants = this._getAllVariants(this._selectableProductVariants);
    const variant = allVariants.find(v => v.platformId.split('/').pop() === variantId);
    if (!variant) return 0;
    return variant.price; 
  }

  _applyOneTimePriceToVariant(variantId) {
    if (!variantId) return;

    const variantPrice = this._getVariantPriceById(variantId);

    const bundleItem = this._bundleItems.find(i => i.id === variantId);
    if (bundleItem) {
      bundleItem.price = variantPrice;
      delete bundleItem.planId; 
    } else {
      this._bundleItems.push({ id: variantId, quantity: 1, price: variantPrice });
    }

    this._updateSubtotalSumBlock();
  }

  _applySellingPlanPriceToVariant(variantId, selectedSellingPlanId, adjustedPrice) {
    if (!variantId || !selectedSellingPlanId) return;

    const selectedPlanGid = Object.keys(this._sellingPlanGroup).find(planGid =>
      planGid.endsWith(selectedSellingPlanId)
    );
    if (!selectedPlanGid) return;

    const planEntry = this._sellingPlanGroup[selectedPlanGid];
    if (!planEntry) return;

    const mappingKey = Object.keys(planEntry.variantMapping).find(gid => gid.endsWith(variantId));
    if (!mappingKey) return;

    const planData = planEntry.variantMapping[mappingKey];
    if (!planData) return;

    const priceToUse = adjustedPrice ?? planData.adjustedPrice;

    const bundleItem = this._bundleItems.find(i => i.id === variantId);
    if (bundleItem) {
      bundleItem.price = priceToUse;
      bundleItem.planId = planData.planId;
    }

    this._updateSubtotalSumBlock();
  }

  _getCurrentPriceData(variantId) {
    const numericVariantId = variantId;
    const selectedPlanInput = document.querySelector('input[name="purchase-option"]:checked');

    if (selectedPlanInput) {
      if (selectedPlanInput.dataset.radioType === 'selling_plan') {
        const selectedSellingPlanId = selectedPlanInput.value;
        const selectedPlanGid = Object.keys(this._sellingPlanGroup).find(planGid =>
          planGid.endsWith(selectedSellingPlanId)
        );
        if (selectedPlanGid) {
          const planData = this._sellingPlanGroup[selectedPlanGid];
          const mappingEntry = Object.entries(planData.variantMapping)
            .find(([gid, mapping]) => gid.endsWith(numericVariantId) && mapping.planId.split('/').pop() === selectedSellingPlanId);

          if (mappingEntry) {
            return {
              price: mappingEntry[1].adjustedPrice,
              planId: selectedSellingPlanId,
              type: 'selling_plan'
            };
          }
        }
      } else if (selectedPlanInput.dataset.radioType === 'one_time_purchase') {
        const variant = this._getAllVariants(this._selectableProductVariants)
          .find(v => v.platformId.split('/').pop() === numericVariantId);
        if (variant) {
          return {
            price: variant.price,
            planId: null,
            type: 'one_time_purchase'
          };
        }
      }
    }

    const variant = this._getAllVariants(this._selectableProductVariants)
      .find(v => v.platformId.split('/').pop() === numericVariantId);
    return {
      price: variant ? variant.price : 0,
      planId: null,
      type: 'one_time_purchase'
    };
  }

  _getComparePriceData(variantId) {
    const numericVariantId = variantId;
    const selectedPlanInput = document.querySelector('input[name="purchase-option"]:checked');
    
    const allVariants = this._getAllVariants(this._selectableProductVariants);
    const variant = allVariants.find(v => v.platformId.split('/').pop() === numericVariantId);
    if (!variant) return { comparePrice: 0 };

    if (selectedPlanInput) {
      if (selectedPlanInput.dataset.radioType === 'selling_plan') {
        const selectedSellingPlanId = selectedPlanInput.value;
        const selectedPlanGid = Object.keys(this._sellingPlanGroup).find(planGid =>
          planGid.endsWith(selectedSellingPlanId)
        );
        if (selectedPlanGid) {
          const planData = this._sellingPlanGroup[selectedPlanGid];
          const mappingEntry = Object.entries(planData.variantMapping)
            .find(([gid, mapping]) => gid.endsWith(numericVariantId) && mapping.planId.split('/').pop() === selectedSellingPlanId);

          if (mappingEntry) {
            return { comparePrice: variant.price };
          }
        }
      } else if (selectedPlanInput.dataset.radioType === 'one_time_purchase') {
        if (variant.compareAtPrice && variant.compareAtPrice > 0) {
          return { comparePrice: variant.compareAtPrice };
        }
      }
    }

    return { comparePrice: variant.compareAtPrice || 0 };
  }

  _setupPurchaseOptionListener() {
    const purchaseOptionInputs = document.querySelectorAll('input[name="purchase-option"]');

    purchaseOptionInputs.forEach(input => {
      const onChange = () => {
        const size = parseInt(this._getCheckedRadioValue('bundle-size')) || 1;

        const block = document.querySelector('[data-box-interval]');
        this._updateIntervalPriceBlock(block, size);
        this._renderBundleCartItems();
        this._updateBundleItemsForPurchaseOption(size);
        this._renderGiftItemsIfEligible(size);
        this._updateAllCardPrices();
      };

    input.addEventListener('change', onChange);
    this._listeners.push({ el: input, type: 'change', fn: onChange });
    });
  }

  _updatePurchasePriceBlock(block, size) {
    const purchasePriceBlocks = block.querySelectorAll('.skio-bundle-builder__price-block');
    const totalDiscountBlocks = block.querySelectorAll('[data-total-discount]');
    
    const allVariants = this._getAllVariants(this._selectableProductVariants);
    const cheapestVariant = this._getCheapestVariant(allVariants);
    const cheapesAdjustedtVariant = this._getCheapestAdjustedVariant(this._sellingPlanGroup);

    if (!cheapestVariant) return;

    purchasePriceBlocks.forEach((purchaseBlock) => {
      const subscriptionPrice = purchaseBlock.hasAttribute('data-subscription-price');
      const priceDefault = purchaseBlock?.querySelector('.price-default');
      const priceCompare = purchaseBlock?.querySelector('.price-compare');
      const cheapestSum = cheapestVariant.price * size;

      if (priceCompare) {
        priceCompare.textContent = subscriptionPrice
          ? `${this._formatMoney(cheapestSum)}`
          : '';
      }
      
      let displayPrice;
      if (subscriptionPrice) {
        const adjustedPrice = (cheapesAdjustedtVariant && cheapesAdjustedtVariant.adjustedPrice > 0)
          ? cheapesAdjustedtVariant.adjustedPrice
          : cheapestVariant.price;

        const percent = parseFloat(this._percentDiscountTier[size]) || 0;
        const discountMultiplier = (100 - percent) / 100;

        displayPrice = adjustedPrice * size * discountMultiplier;
      } else {
        const percent = parseFloat(this._percentDiscountTier[size]) || 0;
        const discountMultiplier = (100 - percent) / 100;
        displayPrice = cheapestVariant.price * size * discountMultiplier;
      }

      if (priceDefault) {
        priceDefault.textContent = `${this._formatMoney(displayPrice.toFixed(2))}`;
      }

      if (totalDiscountBlocks.length) {
        const bundleDiscount = +this._percentDiscountTier[size];

        totalDiscountBlocks.forEach((totalDiscountBlock) => {
          const priceAdjustmentAmount = totalDiscountBlock?.closest('label')?.querySelector('input')?.getAttribute('data-price-adjustment-amount');
          const totalDiscountAmount = +priceAdjustmentAmount + bundleDiscount;
          totalDiscountBlock.textContent = totalDiscountAmount;
        });
      }
    });

    const checkedRadio = block.querySelector('input[type="radio"][data-radio-type="selling_plan"]:checked');
    if (checkedRadio) {
      const bundleDiscount = +this._percentDiscountTier[size];
      const priceAdjustmentAmount = +checkedRadio.dataset.priceAdjustmentAmount;
      const totalDiscountAmount = priceAdjustmentAmount + bundleDiscount;

      const selectedBlock = block.querySelector('.custom-dropdown .selected');
      if (selectedBlock) {
        let discountSpan = selectedBlock.querySelector('[data-total-discount]');
        if (!discountSpan) {
          discountSpan = document.createElement('span');
          discountSpan.dataset.totalDiscount = '';
          selectedBlock.appendChild(discountSpan);
        }
        discountSpan.textContent = totalDiscountAmount;
      }
    }
  }

  _updateSubscriptionSaveBlock(saveBlock, cheapestVariant, cheapestAdjustedVariant, size) {
    if (!saveBlock || !cheapestVariant || !cheapestAdjustedVariant) return;

    const { difference } = this._calculateSubscriptionDiscountSum(
      cheapestVariant,
      cheapestAdjustedVariant,
      size
    );

    const subscriptionSaveBlockText = saveBlock.closest('[data-selling-plans]')?.getAttribute('data-badge-discount-text') || '';

    saveBlock.textContent = `${subscriptionSaveBlockText} ${this._formatMoney(difference)}`;
  }


  _updateSubscriptionTitlePercentBlock(percentBlock, cheapestVariant, cheapestAdjustedVariant, size) {
    if (!percentBlock || !cheapestVariant || !cheapestAdjustedVariant) return;

    const { percent } = this._calculateSubscriptionDiscountSum(
      cheapestVariant,
      cheapestAdjustedVariant,
      size
    );

    percentBlock.textContent = `${percent}%`;
  }

  _getCheckedRadioValue(name) {
    const radios = document.querySelectorAll(`input[name="${name}"]`);
    for (const radio of radios) {
      if (radio.checked) {
        return radio.value;
      }
    }
    return null;
  }

  _getMaxNumber(numbers) {
    if (numbers.length === 0) {
        return null;
    }
    let maxValue = numbers[0];
    for (let i = 1; i < numbers.length; i++) {
        if (numbers[i] > maxValue) {
            maxValue = numbers[i];
        }
    }
    return maxValue;
  }

  _enableFreeGifts(size) {
    const freeGiftsBlock = document.querySelector('[data-free-gifts]');
    const maxSize = this._getMaxNumber(this._sizeInterval);
    if (size == maxSize) {
      if (freeGiftsBlock && freeGiftsBlock.classList.contains('custom-hidden')) {
        freeGiftsBlock.classList.remove('custom-hidden');
      }
    } else {
      if (freeGiftsBlock) {
        freeGiftsBlock.classList.add('custom-hidden');
      }
    }
  }

  _setupIntervalOptionListener() {
    const inputs = document.querySelectorAll('input[name="bundle-size"]');
    const saveBlock = document.querySelector('.skio-bundle-builder__selling-plans-save');
    const percentBlock = document.querySelector('[data-total-percent]');
    const cheapestVariant = this._getCheapestSelectableVariant();
    const cheapestAdjusted = this._getCheapestAdjustedVariant(this._sellingPlanGroup);

    if (!inputs.length) return;

    inputs.forEach(input => {
      const onClick = (event) => {
        const totalQuantity = this._getBundleTotals().totalQuantity;
        const size = parseInt(input.value);
        if (size < totalQuantity) {
          this._showTemporaryAlert({
            text: `Number of items selected is more than ${input.value}`,
            duration: 3000
          });
          event.preventDefault();
          return false;
        }
      };

      const onChange = () => {
        const size = parseInt(input.value);
        const purchaseBlock = document.querySelector('[data-selling-plans]');
        this._updatePurchasePriceBlock(purchaseBlock, size);

        const subscriptionPriceBlock = document.querySelector('.skio-bundle-builder__price-block.subscription-price');
        if (subscriptionPriceBlock) {
          this._renderPriceContainer(cheapestVariant, size, subscriptionPriceBlock, false, true);
        }

        const oneTimePriceBlock = document.querySelector('.skio-bundle-builder__price-block.one-time-price');
        if (oneTimePriceBlock) {
          this._renderPriceContainer(cheapestVariant, size, oneTimePriceBlock, false, false, true);
        }

        if (saveBlock) {
          this._updateSubscriptionSaveBlock(saveBlock, cheapestVariant, cheapestAdjusted, size);
        }

        if (percentBlock) {
          this._updateSubscriptionTitlePercentBlock(percentBlock, cheapestVariant, cheapestAdjusted, size);
        }

        this._enableFreeGifts(size);
        this._updateRemainingQuantityBlock();
        this._toggleCheckoutButton();
        this._updateBundleControls(size);
        this._updateAllCardPrices();
        this._renderBundleCartItems();
      };

      input.addEventListener('click', onClick);
      input.addEventListener('change', onChange);

      this._listeners.push({ el: input, type: 'click', fn: onClick });
      this._listeners.push({ el: input, type: 'change', fn: onChange });
    });
  }

  _updateSubscriptionSaveBlock(saveBlock, cheapestVariant, cheapestAdjustedVariant, size) {
    if (!saveBlock || !cheapestVariant || !cheapestAdjustedVariant) return;

    const { difference } = this._calculateSubscriptionDiscountSum(
      cheapestVariant,
      cheapestAdjustedVariant,
      size
    );

    const subscriptionSaveBlockText = saveBlock.closest('[data-selling-plans]')?.getAttribute('data-badge-discount-text') || '';

    saveBlock.textContent = `${subscriptionSaveBlockText} ${this._formatMoney(difference)}`;
  }

  _calculateSubscriptionDiscountSum(cheapestVariant, cheapestAdjustedVariant, size) {
    const normalPrice = cheapestVariant.price * size;

    const adjustedPrice =
      cheapestAdjustedVariant && cheapestAdjustedVariant.adjustedPrice > 0
        ? cheapestAdjustedVariant.adjustedPrice
        : cheapestVariant.price;

    const subscriptionPrice = adjustedPrice * size;

    const difference = normalPrice - subscriptionPrice;

    const basePercent = normalPrice > 0
      ? Math.round((difference / normalPrice) * 100)
      : 0;

    const subscriptionPercent = parseFloat(this._percentDiscountTier[size]) || 0;

    const percent = basePercent + subscriptionPercent;

    const percentAdjustedDifference = subscriptionPrice * (subscriptionPercent / 100);

    return {
      normalPrice,
      subscriptionPrice,
      difference: difference + percentAdjustedDifference,
      percent
    };
  }


  _resetBundleSelector(card, variant) {
    const cardBottom = card.querySelector('.product-card__bottom');
    const addButton = card.querySelector('.product-card__button');

    const existingSelector = cardBottom.querySelector('.quantity-selector');
    if (existingSelector) {
      cardBottom.removeChild(existingSelector);
      const prevVariantId = existingSelector.dataset.variantId;
      this._bundleItems = this._bundleItems.filter(i => i.id !== prevVariantId);
    }

    if (!cardBottom.contains(addButton)) {
      const addButton = document.createElement('button');
      addButton.classList.add('product-card__button', 'button', 'button--destructive', 'add-button');
      addButton.dataset.label = this._addToCartText;
      addButton.setAttribute('aria-label', this._addToCartText);
      addButton.innerHTML = this._addToCartText;
      addButton.dataset.inCart = 'false';

      const onAddButtonClick = (evt) => this._handleAddButtonClick(evt, card, variant);
      addButton.addEventListener('click', onAddButtonClick);
      this._listeners.push({ el: addButton, type: 'click', fn: onAddButtonClick });
    
      cardBottom.appendChild(addButton);
    }
  }

  _createVariantDropdown(variant, card, variantButton, cardBottom, image) {
    const dropdown = document.createElement('ul');
    dropdown.classList.add('product-card__dropdown');
    dropdown.style.display = 'none';

    const onButtonClick = () => {
      document.querySelectorAll('.product-card__dropdown').forEach(drop => {
        if (drop !== dropdown) drop.style.display = 'none';
      });
      dropdown.style.display = dropdown.style.display === 'none' ? 'block' : 'none';
    };
    variantButton.addEventListener('click', onButtonClick);
    this._listeners.push({ el: variantButton, type: 'click', fn: onButtonClick });

    variant.productVariants.forEach(v => {
      const item = document.createElement('li');
      item.textContent = v.productVariantTitle;

      const onItemClick = () => {
        card.selectedVariant = v;
        const variantId = v.platformId.split('/').pop();
        card.dataset.activeVariantId = variantId;
        variantButton.innerHTML = v.productVariantTitle;
        image.src = v.imageSrc || variant.productImageSrc;

        const priceData = this._getCurrentPriceData(variantId);
        card.querySelector('.product-card__price').textContent = `£${priceData.price.toFixed(2)}`;

        const compareData = this._getComparePriceData(variantId);
        const priceCompare = card.querySelector('.product-card__price-compare');
        priceCompare.innerHTML = '';
        if (compareData.comparePrice > 0) {
          const span = document.createElement('span');
          span.textContent = `£${compareData.comparePrice.toFixed(2)}`;
          priceCompare.appendChild(span);
        }

        dropdown.style.display = 'none';

        const oldSelector = cardBottom.querySelector('.quantity-selector');
        if (oldSelector) cardBottom.removeChild(oldSelector);
        const oldButton = cardBottom.querySelector('.product-card__button');
        if (oldButton) cardBottom.removeChild(oldButton);

        const addButton = document.createElement('button');
        addButton.classList.add('product-card__button', 'button', 'button--destructive');
        addButton.dataset.label = this._addToCartText;
        addButton.setAttribute('aria-label', this._addToCartText);
        addButton.innerHTML = this._addToCartText;
        cardBottom.appendChild(addButton);

        addButton.onclick = () => {
          const selected = card.selectedVariant || v;
          const { container } = this._createBundleQuantitySelector(card, { productVariants: [selected] }, 1);
          container.dataset.variantId = this._getVariantId(selected);

          if (cardBottom.contains(addButton)) {
            cardBottom.replaceChild(container, addButton);
          } else {
            cardBottom.appendChild(container);
          }
        };
      };

      item.addEventListener('click', onItemClick);
      this._listeners.push({ el: item, type: 'click', fn: onItemClick });

      dropdown.appendChild(item);
    });

    return dropdown;
  }

  _handleCartItemByVariant(variantOrSelected, assignToElement = null, returnCartQuantity = false, assignToCard = null) {
    const selectedVariant = variantOrSelected.selectedVariant || variantOrSelected;
    if (!selectedVariant) {
      return;
    }

    const platformId = selectedVariant.platformId;

    if (!platformId) {
      return null;
    }

    const variantId = platformId.slice(platformId.lastIndexOf("/") + 1);

    if (assignToElement) {
      assignToElement.dataset.variantId = variantId;
      return assignToElement;
    } else if (returnCartQuantity) {
      return document.querySelector(`.product-card[data-variant-id="${variantId}"] .quantity-selector span`);
    } else if (assignToCard) {
      assignToCard.dataset.variantId = variantId;
    } else {
      return document.querySelector(`.bundle-cart-item[data-variant-id="${variantId}"]`);
    }
  }

  _sortVariantsByWeight(variants) {
    const extractWeightInGrams = (title) => {
      const match = title.match(/(\d+)\s*(kg|g)/i);
      if (!match) return 0;
      const value = parseFloat(match[1]);
      const unit = match[2].toLowerCase();
      return unit === 'kg' ? value * 1000 : value;
    };

    return variants.sort(
      (a, b) => extractWeightInGrams(a.productVariantTitle) - extractWeightInGrams(b.productVariantTitle)
    );
  }

  _applyPriceToVariantCard(variantId) {
    const priceData = this._getCurrentPriceData(variantId);
    const bundleItem = this._bundleItems.find(i => i.id === variantId);

    if (bundleItem) {
      bundleItem.price = priceData.price;
      bundleItem.planId = priceData.planId;
    }

    const priceElement = document.querySelector(`.product-card[data-active-variant-id="${variantId}"] .product-card__price`);
    if (priceElement) priceElement.textContent = `£${priceData.price.toFixed(2)}`;
  }

  _handleAddButtonClick(evt, card, variant) {
    evt.preventDefault();

    const selected = card.selectedVariant || variant.productVariants[0];

    const cardBottom = card.querySelector('.product-card__bottom');
    const existingSelector = cardBottom.querySelector('.quantity-selector');
    if (existingSelector) {
      cardBottom.removeChild(existingSelector);
    }

    const result = this._createBundleQuantitySelector(card, { productVariants: [selected] }, 1);

    if (result && result.container instanceof HTMLElement) {
      const addButton = cardBottom.querySelector('.product-card__button');
      if (addButton && cardBottom.contains(addButton)) {
        cardBottom.replaceChild(result.container, addButton);
      } else {
        cardBottom.appendChild(result.container);
      }
    }
  }

  _createProductCard(variant) {
    const card = document.createElement('div');
    card.classList.add('product-card');
    card._variantData = variant;

    variant.productVariants = this._sortVariantsByWeight(variant.productVariants);

    const cardVariantId = variant.productVariants[0].platformId.split('/').pop();
    
    card.dataset.activeVariantId = cardVariantId;

    let selectedVariant = variant.productVariants[0];
    card.selectedVariant = selectedVariant;

    const cardContent = document.createElement('div');
    cardContent.classList.add('product-card__content');

    const title = document.createElement('h3');
    title.classList.add('skio-bundle-builder__title-heading');
    title.innerHTML = `<span>${variant.productTitle}</span>`;

    const cardBottom = document.createElement('div');
    cardBottom.classList.add('product-card__bottom');

    const priceContainer = document.createElement('div');
    priceContainer.classList.add('product-card__price-container');

    const priceCompare = document.createElement('p');
    priceCompare.classList.add('product-card__price-compare');
    const compareData = this._getComparePriceData(cardVariantId);
    if (compareData.comparePrice > 0) {
      const span = document.createElement('span');
      span.textContent = `${this._formatMoney(compareData.comparePrice)}`;
      priceCompare.appendChild(span);
    }

    const price = document.createElement('p');
    price.classList.add('product-card__price');
    const priceData = this._getCurrentPriceData(cardVariantId);
    price.textContent = `${this._formatMoney(priceData.price)}`;

    const image = document.createElement('img');
    image.src = selectedVariant.imageSrc || variant.productImageSrc;;
    image.alt = selectedVariant.productTitle;

    const variantContainer = document.createElement('div');
    variantContainer.classList.add('product-card__variant-container');

    if (variant.productVariants.length > 1) {      
      card.selectedVariant = selectedVariant;

      const variantButton = document.createElement('button');
      variantButton.classList.add('product-card__variant-button');
      variantButton.innerHTML = selectedVariant.productVariantTitle;

      const svgWrapper = document.createElement('span');
      svgWrapper.classList.add('product-card__variant-icon');
      svgWrapper.innerHTML = this._svgDropdown;

      const dropdown = this._createVariantDropdown(variant, card, variantButton, cardBottom, image);

      variantContainer.appendChild(variantButton);
      variantContainer.appendChild(svgWrapper);
      variantContainer.appendChild(dropdown);
    }

    const addButton = document.createElement('button');
    addButton.classList.add('product-card__button', 'button', 'button--destructive', 'add-button');
    addButton.dataset.label = this._addToCartText;
    addButton.setAttribute('aria-label', this._addToCartText);
    addButton.innerHTML = this._addToCartText;
    addButton.dataset.inCart = 'false';

    const onAddButtonClick = (evt) => this._handleAddButtonClick(evt, card, variant);
    addButton.addEventListener('click', onAddButtonClick);
    this._listeners.push({ el: addButton, type: 'click', fn: onAddButtonClick });
    
    card.appendChild(image);
    card.appendChild(cardContent);
    cardContent.appendChild(title);
    cardContent.appendChild(priceContainer);
    cardContent.appendChild(variantContainer);
    cardContent.appendChild(cardBottom);
    priceContainer.appendChild(priceCompare);
    priceContainer.appendChild(price);    
    cardBottom.appendChild(addButton);

    return card;
  }

  _updateCardPrice(card) {
    const variantId = card.selectedVariant.platformId.split('/').pop();
    const priceData = this._getCurrentPriceData(variantId);
    const compareData = this._getComparePriceData(variantId);

    const size = parseInt(this._getCheckedRadioValue('bundle-size')) || 1;
    const percent = parseFloat(this._percentDiscountTier[size]) || 0;
    const discountMultiplier = (100 - percent) / 100;

    const priceEl = card.querySelector('.product-card__price');
    const compareEl = card.querySelector('.product-card__price-compare');
    const finalPrice = priceData.price * discountMultiplier;

    priceEl.textContent = `${this._formatMoney(finalPrice)}`;

    compareEl.innerHTML = '';
    if (compareData.comparePrice > 0) {
      compareEl.textContent = `${this._formatMoney(compareData.comparePrice * size)}`;
    } else if (priceData.type === 'selling_plan') {
      const originalPrice = this._getVariantPriceById(variantId, true);
      compareEl.textContent = `${this._formatMoney(originalPrice * size)}`;
    }
  }


  _renderCategoryIcon(categoryName, targetElement) {
    if (!categoryName || !targetElement) return;

    const key = categoryName.toLowerCase().replace(/\s+/g, '-');

    const iconsJSON = document.getElementById('category-icons');
    if (!iconsJSON) return;

    let icons;
    try {
      icons = JSON.parse(iconsJSON.textContent);
    } catch (e) {
      console.error('Failed to parse category icons JSON', e);
      return;
    }

    const svg = icons[key];
    if (svg) {
      targetElement.innerHTML = svg;
    } else {
      targetElement.innerHTML = '';
      console.warn(`No icon found for category: ${categoryName}`);
    }
  }

  _renderProductCards() {
    const container = document.createElement('div');
    container.classList.add('skio-bundle-builder__product-container');

    if (this._groupedProducts && typeof this._groupedProducts === 'object') {
      const orderedCategories = this._productGroupingOrder || [];

      orderedCategories.forEach(category => {
        const variants = this._groupedProducts?.[category];
        if (!variants || variants.length === 0) {
          console.warn('Skipping category because no variants:', category);
          return;
        }

        const categoryBlock = document.createElement('div');
        categoryBlock.classList.add('skio-bundle-builder__product-category-block');
        categoryBlock.dataset.category = category;

        const iconContainer = document.createElement('div');
        iconContainer.classList.add('skio-bundle-builder__product-category-icon');

        this._renderCategoryIcon(category, iconContainer);

        const heading = document.createElement('h2');
        const headingText = document.createElement('span');
        headingText.textContent = category;
        heading.classList.add('skio-bundle-builder__product-category-title');

        const productList = document.createElement('div');
        productList.classList.add('skio-bundle-builder__product-list');

        variants.forEach(variant => {
          const card = this._createProductCard(variant);
          productList.appendChild(card);
        });
        
        heading.appendChild(iconContainer);
        heading.appendChild(headingText);
        categoryBlock.appendChild(heading);
        categoryBlock.appendChild(productList);
        container.appendChild(categoryBlock);
      });

    } else {
      console.error('Unexpected data structure:', this._groupedProducts);
    }

    this._elements.boxContainer.appendChild(container);
  }   

  _getVariantId(selectedVariant) {
    return selectedVariant.platformId.split('/').pop();
  }  

  _getVariantPrice(selectedVariant) {
    return selectedVariant.price;
  }  

  _resetCardToAddButton(card, addButton) {
    const cardBottom = card.querySelector('.product-card__bottom');

    if (!cardBottom.contains(addButton)) {
      cardBottom.appendChild(addButton);
    }

    const selector = cardBottom.querySelector('.quantity-selector');
    if (selector) cardBottom.removeChild(selector);
  }

  _createBundleQuantitySelector(card, variant, initialQuantity = 0) {
    const selected = card.selectedVariant || variant.productVariants[0];
    const variantId = this._getVariantId(selected);

    const addButton = card.querySelector('.product-card__button');
    const cardBottom = card.querySelector('.product-card__bottom');

    const container = document.createElement('div');
    container.classList.add('quantity-selector');

    const minusBtn = document.createElement('button');
    minusBtn.classList.add('minus');
    minusBtn.type = 'button';
    minusBtn.innerHTML = this._svgMinus;

    const display = document.createElement('span');
    display.classList.add('quantity-display');
    display.textContent = '0';

    const plusBtn = document.createElement('button');
    plusBtn.classList.add('plus');
    plusBtn.type = 'button';
    plusBtn.innerHTML = this._svgPlus;

    container.append(minusBtn, display, plusBtn);

    const updateQty = (delta) => {
      this._addToBundle(selected, delta);

      const item = this._bundleItems.find(i => i.id === variantId);
      display.textContent = item ? item.quantity : '0';

      if (!item || item.quantity <= 0) {
        this._removeFromBundleById(variantId);

        if (cardBottom.contains(container)) cardBottom.removeChild(container);

        const addButton = card.querySelector('.product-card__button');
        this._resetCardToAddButton(card, addButton);
      }
    };

    const onPlus = () => updateQty(1);
    const onMinus = () => updateQty(-1);

    plusBtn.addEventListener('click', onPlus);
    minusBtn.addEventListener('click', onMinus);

    this._listeners.push({ el: plusBtn, type: 'click', fn: onPlus });
    this._listeners.push({ el: minusBtn, type: 'click', fn: onMinus });

    if (initialQuantity > 0) {
      updateQty(initialQuantity);
    }

    return { container, display };
  }

  _resetCardToAddButton(card, addButton) {
    const cardBottom = card.querySelector('.product-card__bottom');

    const existingSelector = cardBottom.querySelector('.quantity-selector');
    if (existingSelector) cardBottom.removeChild(existingSelector);

    if (!cardBottom.contains(addButton)) {
      cardBottom.appendChild(addButton);
    }
  }

  _updateBundleControls(maxSize) {
    const { totalQuantity } = this._getBundleTotals(); 

    document.querySelectorAll('.add-button').forEach(btn => {
      btn.disabled = totalQuantity >= maxSize;
      btn.classList.toggle('disabled', totalQuantity >= maxSize);
    });

    document.querySelectorAll('.quantity-selector .plus').forEach(plusBtn => {
      plusBtn.disabled = totalQuantity >= maxSize;
      plusBtn.classList.toggle('disabled', totalQuantity >= maxSize);
    });

    if (totalQuantity >= maxSize) {
      this._showTemporaryAlert({
        text: `You've selected ${totalQuantity} items already`,
        duration: 3000
      });
    }
  }

  _getBundleTotals() {
    let totalQuantity = 0;
    let totalOriginalPrice = 0;

    const selectedSizeInput = document.querySelector('input[name="bundle-size"]:checked');
    const selectedSize = selectedSizeInput ? parseInt(selectedSizeInput.value) : 1;

    this._bundleItems.forEach(item => {
      const quantity = parseInt(item.quantity || 1);
      totalQuantity += quantity;

      const original = item.originalPrice != null ? item.originalPrice : item.price;
      totalOriginalPrice += original * quantity;
    });

    const percent = parseFloat(this._percentDiscountTier[selectedSize]) || 0;
    const discountMultiplier = (100 - percent) / 100;

    let totalPrice = 0;

    this._bundleItems.forEach(item => {
      const quantity = parseInt(item.quantity || 1);
      const isSubscription = item.isSubscription === true;
      const isOneTime = item.isOneTime === true;

      let pricePerItem;

      if (isSubscription) {
        const adjustedPrice = (item.adjustedPrice && item.adjustedPrice > 0) ? item.adjustedPrice : item.price;
        pricePerItem = adjustedPrice;
      } else if (isOneTime) {
        pricePerItem = item.price * discountMultiplier;
      } else {
        pricePerItem = item.price * discountMultiplier;
      }

      totalPrice += pricePerItem * quantity;
    });

    const totalSavings = Math.max(0, totalOriginalPrice - totalPrice);

    return { totalQuantity, totalPrice, totalOriginalPrice, totalSavings };
  }

  _getBundleSelectionStatus() {
    const maxSize = this._getSelectedBundleTotalSize(); 
    const { totalQuantity } = this._getBundleTotals();  

    const selectedQuantity = totalQuantity;
    const remainingQuantity = Math.max(maxSize - totalQuantity, 0); 

    return { selectedQuantity, remainingQuantity, maxQuantity: maxSize };
  }

  _showTemporaryAlert({ duration = 3000, text } = {}) {
    if (this._elements.alertContainer) {
     
      this._elements.alertContainer.innerHTML = text;
      this._elements.alertContainer.classList.remove('custom-hidden');

      clearTimeout(this._removeAlert);
      this._removeAlert = setTimeout(() => {
        this._elements.alertContainer.innerHTML = '';
        this._elements.alertContainer.classList.add('custom-hidden');
      }, duration);
    }
  }

  _updateRemainingQuantityBlock() {
    if (!this._elements?.remainQuantityBlock || !this._elements?.remainQuantityContainer) return;

    const { remainingQuantity, maxQuantity } = this._getBundleSelectionStatus();
    const usedQuantity = maxQuantity - remainingQuantity;

    this._elements.remainQuantityBlock.textContent = `${remainingQuantity}`;

    if (remainingQuantity === 0) {
      this._elements.remainQuantityContainer.classList.add('custom-hidden');
    } else {
      this._elements.remainQuantityContainer.classList.remove('custom-hidden');
    }

    const progress = (usedQuantity / maxQuantity) * 100;

    const fillEl = this._elements.remainQuantityContainer.querySelector('.btn-fill');
    if (fillEl) {
      fillEl.style.width = `${progress}%`;
    }
  }

  _updateSubtotalSumBlock() {
    if (!this._elements?.subtotalSumBlock) return;

      const { totalPrice, totalSavings } = this._getBundleTotals();

      this._elements.subtotalSumBlock.textContent = `${this._formatMoney(totalPrice)}`;

      if (this._elements.saveBlock) {
      if (totalSavings > 0) {
        this._elements.saveBlock.textContent = `${this._formatMoney(totalSavings)}`;
        this._elements.saveBlock.closest('.skio-bundle-builder__discount').classList.remove('custom-hidden');
      } else {
        this._elements.saveBlock.closest('.skio-bundle-builder__discount').classList.add('custom-hidden');
      }
    }
  }

  _toggleCheckoutButton() {
    if (!this._elements?.checkoutButton || !this._elements?.checkoutBlock) return;

    const remainingQuantity = parseInt(this._elements.remainQuantityBlock.textContent, 10);

    if (remainingQuantity === 0) {
      this._elements.checkoutBlock.classList.remove('custom-hidden');
      this._elements.checkoutButton.classList.remove('custom-hidden');
    } else {
      this._elements.checkoutBlock.classList.add('custom-hidden');
      this._elements.checkoutButton.classList.add('custom-hidden');
    }
  }

  _updateBundleItemsForPurchaseOption() {
    this._bundleItems = this._bundleItems.map(item => {
      const priceData = this._getCurrentPriceData(item.id); 
      return {
        ...item,
        price: priceData.price,
        planId: priceData.planId
      };
    });

    const maxSize = this._getSelectedBundleTotalSize();
    this._updateBundleControls(maxSize);
    this._updateRemainingQuantityBlock();
    this._updateSubtotalSumBlock();
    this._toggleCheckoutButton();
    this._renderBundleCartItems();
  }

  _addToBundle(variant, qty = 1) {
    const maxSize = this._getSelectedBundleTotalSize(); 
    const { totalQuantity } = this._getBundleTotals();

    if (totalQuantity + qty > maxSize) {
      this._updateBundleControls(maxSize);
      this._updateRemainingQuantityBlock();
      this._updateSubtotalSumBlock();
      this._toggleCheckoutButton();
      return; 
    }

    const variantId = this._getVariantId(variant);
    const priceData = this._getCurrentPriceData(variantId);

    const existing = this._bundleItems.find(i => i.id === variantId);

    if (existing) {
      existing.quantity += qty;

      if (existing.quantity <= 0) {
        this._bundleItems = this._bundleItems.filter(i => i.id !== variantId);
      } else {
        existing.price = priceData.price;       
        existing.planId = priceData.planId; 
        if (!existing.originalPrice) {
          existing.originalPrice = this._getVariantPrice(variant, true); 
        }
      }

    } else if (qty > 0) {
      this._bundleItems.push({
        id: variantId,
        quantity: qty,
        price: priceData.price,
        originalPrice: this._getVariantPrice(variant, true), 
        planId: priceData.planId
      });
    }

    this._updateBundleControls(maxSize);
    this._updateRemainingQuantityBlock();
    this._updateSubtotalSumBlock();
    this._toggleCheckoutButton();
    this._renderBundleCartItems();
    this._updateCloseButtonState();
    this._renderGiftItemsIfEligible();
  }

  _removeFromBundle(variant, qty = 1) {
    const variantId = this._getVariantId(variant);
    const existing = this._bundleItems.find(i => i.id === variantId);
    if (!existing) return;
    existing.quantity -= qty;
    if (existing.quantity <= 0) this._bundleItems = this._bundleItems.filter(i => i.id !== variantId);
  }

  _getBundleItemQty(variantId) {
    const existing = this._bundleItems.find(i => i.id === variantId);
    return existing ? existing.quantity : 0;
  }

  _isGiftSelected() {
    const giftSelected = document.querySelector('input[name="free-gift"]:checked');
    return !!giftSelected;
  }

  _setupGiftOptionListener() {
    const giftOptionInputs = document.querySelectorAll('input[name="free-gift"]');

    const onGiftChange = () => {
      this._isGiftSelected();
    };    

    giftOptionInputs.forEach(input => {
      input.addEventListener('change', () => {
        this._renderGiftItemsIfEligible();
        onGiftChange();
        this._listeners.push({ el: input, type: 'click', fn: onGiftChange });
      });
    });
  }

  _getSelectedGifts() {
    const selected = [...document.querySelectorAll('input[name="free-gift"]:checked')];
    return selected.map(input => input.value);
  }

  _resetBundleUI() {
    document.querySelectorAll('.add-button').forEach(btn => {
      btn.classList.remove('disabled');
      btn.disabled = false;
    });

    const allCards = document.querySelectorAll('.product-card');
    allCards.forEach(card => {
      const variant = card._variantData;
      this._resetBundleSelector(card, variant);
    });

    this._updateSubtotalSumBlock();

    this._bundleItems = [];
    this._updateRemainingQuantityBlock();
    this._toggleCheckoutButton();
    this._renderBundleCartItems();
  }

  _removeFromBundleById(variantId) {
    const allVariants = this._getAllVariants(this._selectableProductVariants);
    const variant = allVariants.find(v => v.platformId.split('/').pop() === String(variantId));
    const maxSize = this._getMaxNumber(this._sizeInterval);

    if (variant) {
      const card = document.querySelector(`.product-card[data-active-variant-id="${variantId}"]`);
      
      const existingItem = this._bundleItems.find(i => i.id === variantId);
      if (existingItem) {
        this._removeFromBundle(variant, existingItem.quantity);
      }

      if (card) {
        this._resetBundleSelector(card, variant);
      }

      this._renderBundleCartItems();
      this._updateSubtotalSumBlock();
      this._updateRemainingQuantityBlock();
      this._toggleCheckoutButton();
      this._updateBundleControls(maxSize);
      this._updateCloseButtonState();
    }
  }

  _renderBundleCartItems() {
    const container = this._elements.bundleCart;
    if (!container) return;

    container.innerHTML = '';

    if (!this._bundleItems.length) return;

    const allProducts = this._selectableProductVariants;

    this._bundleItems.forEach(item => {
      const product = allProducts.find(prod =>
        Array.isArray(prod.productVariants) &&
        prod.productVariants.some(v => v.platformId.split('/').pop() === String(item.id))
      );

      if (!product) return;

      const variantData = product.productVariants.find(
        v => v.platformId.split('/').pop() === String(item.id)
      );

      if (!variantData) return;

      const itemEl = document.createElement('div');
      itemEl.classList.add('bundle-cart-item');
      itemEl.dataset.variantId = item.id;

      const img = document.createElement('img');
      img.src = variantData.imageSrc || product.productImageSrc || '';
      img.alt = variantData.productVariantTitle || product.productTitle;

      const title = document.createElement('p');
      title.classList.add('bundle-cart-item__title');
      const productVariantTitle = variantData.productVariantTitle === 'Default Title' ? '' : `- ${variantData.productVariantTitle}`;
      title.textContent = `${product.productTitle} ${productVariantTitle}`;

      const priceContainer = document.createElement('div');
      priceContainer.classList.add('bundle-cart-item__prices');

      const bundleSize = parseInt(this._getCheckedRadioValue('bundle-size')) || parseInt(item.quantity || 1);
      const itemQuantity = parseInt(item.quantity || 1);

      const percent = parseFloat(this._percentDiscountTier[bundleSize]) || 0;
      const discountMultiplier = (100 - percent) / 100;

      const subscriptionInput = document.querySelector('input[name="purchase-type"]:checked');
      const isSubscription = subscriptionInput && subscriptionInput.value === 'subscription';
      const isOneTime = !isSubscription;

      if (item.originalPrice && item.originalPrice > item.price) {
        const compare = document.createElement('span');
        compare.classList.add('bundle-cart-item__compare');
        compare.textContent = this._formatMoney(item.originalPrice * itemQuantity);
        priceContainer.appendChild(compare);
      }

      const price = document.createElement('span');
      price.classList.add('bundle-cart-item__price');

      const finalPrice = (isSubscription || isOneTime)
        ? item.price * itemQuantity * discountMultiplier
        : item.price * itemQuantity;

      price.textContent = this._formatMoney(finalPrice);
      priceContainer.appendChild(price);

      const removeBtn = document.createElement('button');
      removeBtn.classList.add('bundle-cart-item__remove');
      removeBtn.innerHTML = this._svgDelete;

      const onRemoveFromCartClick = () => {
        this._removeFromBundleById(item.id);
      };

      this._listeners.push({ el: removeBtn, type: 'click', fn: onRemoveFromCartClick });
      removeBtn.addEventListener('click', onRemoveFromCartClick);

      itemEl.appendChild(img);
      itemEl.appendChild(title);
      itemEl.appendChild(priceContainer);
      itemEl.appendChild(removeBtn);

      container.appendChild(itemEl);
    });
  }


  _setDeliveryDate() {
    const date = new Date();
    date.setDate(date.getDate() + this._deliveryDays);

    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'long' });

    function getDaySuffix(d) {
      if (d > 3 && d < 21) return 'th';
      switch (d % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    }

    const formattedDate = `${day}${getDaySuffix(day)} ${month}`;

    const element = document.querySelector('[data-delivery-date]');
    if (element) {
      element.setAttribute('data-delivery-date', formattedDate);
      element.textContent = formattedDate;
    }
  }

  _setupCartCloseHandler() {
    if (!this._elements.closeButton || !this._elements.bundleCart) {
      return;
    }
    const onCartCloseClick = () => {
      if (!this._bundleItems.length) {
        return;
      }

      this._elements.bundleCart.closest('.skio-bundle-builder__totals-cart').classList.toggle('reduced-height');
      this._elements.closeButton.classList.toggle('rotate');
    }

    this._listeners.push({ el: this._elements.closeButton, type: 'click', fn: onCartCloseClick });

    this._elements.closeButton.addEventListener('click', onCartCloseClick);
  }    

  _updateCloseButtonState() {
    if (this._bundleItems.length <= 0) {
      this._elements.closeButton.classList.add('custom-hidden');
    } else {
      this._elements.closeButton.classList.remove('custom-hidden');
    }
  }

  _showTotalsOnScroll() {
    const step = document.querySelector('.step-two');
    const blockToChange = document.querySelector('.skio-bundle-builder__totals'); 
    const cartItems = document.querySelector('.skio-bundle-builder__totals-cart-items');
    const header = document.querySelector('.section-header');

    if (!step || !blockToChange || !cartItems || !header) return;
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    const isCartEmpty = () => !cartItems.children.length;

    const toggleVisibility = () => {
      const stepTop = step.getBoundingClientRect().top;
      const headerBottom = header.offsetHeight;

      if (!isCartEmpty()) {
        blockToChange.classList.add('is-visible');
      } else if (stepTop <= headerBottom) {
        blockToChange.classList.add('is-visible');
      } else {
        blockToChange.classList.remove('is-visible');
      }
    };

    const onPageScroll = () => toggleVisibility();
    window.addEventListener('scroll', onPageScroll);
    this._listeners.push({ el: window, type: 'scroll', fn: onPageScroll });

    const mutationObserver = new MutationObserver(toggleVisibility);
    mutationObserver.observe(cartItems, { childList: true, subtree: true });

    toggleVisibility();

    return () => {
      mutationObserver.disconnect();
    };
  }

  _getSelectedGiftsIfEligible() {
    const maxSize = this._getMaxNumber(this._sizeInterval);
    const { totalQuantity } = this._getBundleTotals();

    if (totalQuantity < maxSize) return [];

    return this._getSelectedGifts().map(id => ({
      id: Number(id),
      quantity: 1
    }));
  }

  _renderGiftItemsIfEligible() {
    const giftItemsContainer = document.querySelector('[data-cart-items]');
    if (!giftItemsContainer) return;

    giftItemsContainer.querySelectorAll('.bundle-cart-item.gift-item').forEach(el => el.remove());

    const giftItems = this._getSelectedGiftsIfEligible();

    giftItems.forEach(item => {
      const li = document.createElement('div');
      li.classList.add('bundle-cart-item', 'gift-item');
      li.dataset.variantId = item.id;

      const inputEl = document.querySelector(`input[value="${item.id}"]`);
      const label = inputEl?.closest('.skio-bundle-builder__free-gift');

      const imgSrc = label?.querySelector('img')?.src || '';
      const title = label?.querySelector('p')?.textContent || 'Gift';
      const priceText = label?.querySelector('.price-default')?.textContent || '';

      li.innerHTML = `
        <img src="${imgSrc}" alt="${title}" class="bundle-cart-item__image" />
        <div class="bundle-cart-item__info">
          <p class="bundle-cart-item__title">${title}</p>
          <p class="bundle-cart-item__price">${priceText}</p>
        </div>
      `;

      giftItemsContainer.appendChild(li);
    });
  }

  async _addBundleToCart() {
    if (!this._bundleItems.length) return;

    const checkoutBtn = document.querySelector('.skio-bundle-builder__checkout');
    const spinner = checkoutBtn?.querySelector('.spinner');
    const buttonText = checkoutBtn?.querySelector('span');

    spinner?.classList.remove('custom-hidden');
    if (buttonText) buttonText.textContent = 'Adding...';
    checkoutBtn.disabled = true;

    const maxSize = this._getMaxNumber(this._sizeInterval);
    const { totalQuantity } = this._getBundleTotals();

    let boxIndex = 0;
    try {
      const cartResponse = await fetch('/cart.js');
      const cartData = await cartResponse.json();      
      const existingBoxIndexes = cartData.items
        .map(cartItem => Number(cartItem.properties?._dynamicBoxIndex))
        .filter(index => !isNaN(index));

      if (existingBoxIndexes.length > 0) {
        boxIndex = Math.max(...existingBoxIndexes) + 1;
      }
    } catch (err) {
      console.error('Error:', err);
    }

    const itemsToAdd = [...this._bundleItems];

    let giftItems = [];
    if (totalQuantity >= maxSize) {
      const giftIds = this._getSelectedGifts(); 
      giftItems = giftIds.map(id => ({
        id: Number(id), 
        quantity: 1
      }));
    }

    const allItems = [
      ...itemsToAdd.map(item => {
        const body = {
          id: Number(item.id),      
          quantity: Number(item.quantity), 
          properties: {
            _dynamicBoxIndex: boxIndex,
            _dynamicBoxId: this._boxId
          }
        };
        if (item.planId) body.selling_plan = Number(item.planId); 
        return body;
      }),
      ...giftItems
    ];

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' 
      },
        body: JSON.stringify({ items: allItems })
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error:', errorText);
        throw new Error(errorText);
      }

      this._bundleItems = [];

      spinner?.classList.add('custom-hidden');
      if (buttonText) buttonText.textContent = 'Checkout';
      checkoutBtn.disabled = false;

      this._resetBundleUI();

      window.location.href = '/checkout';
    } catch (err) {
      console.error('Error:', err);
      spinner?.classList.add('custom-hidden');
      if (buttonText) buttonText.textContent = 'Checkout';
      checkoutBtn.disabled = false;
    }
  }

  _setupCheckoutButtonListener() {
    const checkoutBtn = this._elements.checkoutButton;

    if (!checkoutBtn) return;

    const onCheckoutClick = async (e) => {
      e.preventDefault();
      await this._addBundleToCart();
    };
    checkoutBtn.addEventListener('click', onCheckoutClick);
    this._listeners.push({ el: checkoutBtn, type: 'click', fn: onCheckoutClick });
  }

  _removeAllListeners() {
    this._listeners.forEach(({ el, type, fn }) => {
      el.removeEventListener(type, fn);
    });
    this._listeners = [];
  }
}

const bundleBlock = document.querySelector('.skio-bundle-builder__categories-wrapper');

let bundleInstance = null;

if (bundleBlock) {
  const bundleId = bundleBlock.dataset.bundleId;

  bundleInstance = new BundleBox(
    'https://api.skio.com/storefront-http/get-dynamic-box',
    bundleId
  );
}

window.addEventListener("beforeunload", () => {
  bundleInstance.removeAllListeners();
  bundleInstance = null;
});